import React from 'react';
import { Link } from 'react-router-dom';
import './Details2.css';
import details2Bg from '../../assets/bg-dt.svg';

function Details2() {
  return (
    <section className="details2-section">
      <div
        className="container responsive-container"
        style={{
          backgroundImage: `url(${details2Bg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="details2-content">
          <div className="text-content">
            <h2>
              World class <br className="desktop-break" />
              therapy for everyone
            </h2>
            <p>Experience an evolving, evidence-based AI platform 
            designed to be your mental health companion—24/7, anywhere, at no cost.</p>

            <Link to="/chat" className="btn primary">Try for free</Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Details2; 